export default class BurgerButton {

  constructor (burger) {
    this.burgerEl = burger;

    this._bindEvents();
  }

  _bindEvents() {
    $(this.burgerEl).on('click', (e) => {
      e.stopPropagation();

      $(this.burgerEl).toggleClass('burger--closed');

      let eventName = $(this.burgerEl).hasClass('burger--closed') ? 'burgeropen' : 'burgerclosed';
      $(this.burgerEl).trigger( eventName );
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/burgerButton.js